<template>
  <el-dialog :title="title" :visible.sync="visible" width="500px" :before-close="handleClose" :close-on-click-modal="false">
    <el-form ref="form" :model="form" :rules="rules" :show-message="showMessage">
      <el-form-item label="客户端类型" prop="type">
        <el-select v-model="form.type" placeholder="请选择客户端类型">
          <el-option v-for="[key, value] in APP_TYPE_MAP" :key="key" :value="key" :label="value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="版本号" prop="version">
        <el-input v-model="form.version" placeholder="请输入版本号" @focus="inputFocus"></el-input>
      </el-form-item>
      <el-form-item label="是否强制更新" prop="forced">
        <el-select v-model="form.forced" placeholder="是否强制更新">
          <el-option v-for="[key, value] in APP_FORCED_MAP" :key="key" :value="key" :label="value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.type !== 0" label="安装包上传" prop="packageUrl">
        <el-upload
          v-if="visible"
          ref="uploaderTemplate"
          action=""
          :auto-upload="false"
          :fileList="fileList"
          :on-change="handleFileChange"
          :on-remove="handleRemoveFile"
          @click="inputFocus"
        >
          <el-button :loading="uploading" size="small" type="primary" @click="inputFocus">点击上传</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item v-else label="安装包地址" prop="packageUrl">
        <el-input v-model="form.packageUrl" placeholder="请输入安装包地址" @focus="inputFocus"></el-input>
      </el-form-item>
      <el-form-item label="更新文案" prop="description">
        <el-input
          v-model="form.description"
          placeholder="更新文案"
          type="textarea"
          maxlength="500"
          show-word-limit
          :rows="5"
        ></el-input>
      </el-form-item>
      <transition enter-active-class="animated fadeInDown" leave-active-class="animated fadeOutUp">
        <el-form-item v-show="!showMessage && errTips !== ''" class="err-tips">
          <span><i class="el-icon el-icon-remove"></i>{{errTips}}</span>
        </el-form-item>
      </transition>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button :disabled="!canSubmit" type="primary" style="width: 120px;" @click="handleUpdate">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { PUT_IMAGE_UPLOAD, PUT_APP_VERSIONS, POST_APP_VERSIONS } from '@/utils/api'
import { APP_TYPE_MAP, APP_FORCED_MAP } from '@/utils/global-constant'
export default {
  name: 'EditAppDialog',

  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false
    },

    app: {
      type: Object,
      required: false,
      default: () => {
        return {}
      }
    }
  },

  data () {
    this.checkValue = (rule, value, callback, tips) => {
      let errTips = ''
      if (value === '') {
        errTips = tips
      }

      if (errTips) {
        !this.errTips && (this.errTips = errTips)
        callback(new Error(errTips))
      } else {
        callback()
      }
    }

    return {
      title: '',
      form: {
        type: 1,
        forced: '',
        version: '',
        packageUrl: '',
        description: ''
      },
      showMessage: true,
      rules: {
        type: [
          {required: true, validator: (rule, value, callback) => this.checkValue(rule, value, callback, '请选择客户端类型'), trigger: 'blur'}
        ],
        version: [
          {required: true, validator: (rule, value, callback) => this.checkValue(rule, value, callback, '请输入版本号'), trigger: 'blur'}
        ],
        forced: [
          {required: true, validator: (rule, value, callback) => this.checkValue(rule, value, callback, '请选择是否强制更新'), trigger: 'blur'}
        ],
        packageUrl: [
          {required: true, validator: this.checkPackageUrl, trigger: 'change'}
        ]
      },
      errTips: '',
      uploading: false,
      fileList: [],
      APP_TYPE_MAP,
      APP_FORCED_MAP
    }
  },

  computed: {
    canSubmit () {
      return this.form.forced !== '' && this.form.version !== '' && this.form.packageUrl !== ''
    },

    requestHeaders () {
      const data = {}
      this.$store.state.user && (data.token = this.$store.state.user.token)
      return data
    }
  },

  watch: {
    visible (val) {
      if (this.app.hasOwnProperty('id')) {
        this.title = '编辑APP'
        this.form = Object.assign({
          type: 1
        }, this.app)
        this.fileList = [
          {name: this.app.packageUrl.split('/').pop(), url: this.app.packageUrl}
        ]
      } else {
        this.title= '新增APP'
        this.form = {
          type: 1,
          forced: '',
          version: '',
          packageUrl: '',
          description: ''
        }
        this.fileList = []
      }
      setTimeout(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      }, val ? 0 : 300)
    },

    showMessage (val) {
      !val && (this.errTips = '')
    }
  },

  methods: {
    // 关闭前
    handleClose () {
      this.$emit('close')
      setTimeout(() => {
        this.fileList = []
      }, 100)
    },

    // 数据更新前
    handleUpdate () {
      this.showMessage = false
      setTimeout(() => {
        this.submit()
      }, 10)
    },

    // 提交数据
    submit () {
      this.$refs.form &&
      this.$refs.form.validate(async validateResult => {
        if (validateResult) {
          try {
            const isEdit = this.app.hasOwnProperty('id')
            const data = Object.assign({}, this.form)
            isEdit ? await POST_APP_VERSIONS(this.app.id, data) : await PUT_APP_VERSIONS(data)
            this.$message.success(isEdit ? '编辑成功' : '新增成功')
            this.$emit('update')
          } catch (e) {
            this.$message.error('操作失败')
          }
        }
      })
    },

    // 输入框聚焦
    inputFocus () {
      !this.showMessage && this.$refs.form && this.$refs.form.clearValidate()
      this.showMessage = true
    },


    checkPackageUrl (rule, value, callback) {
      let errTips = ''
      if (value === '') {
        errTips = this.form.type === 0 ? '请输入安装包地址' : '请上传安装包'
      }

      if (errTips) {
        !this.errTips && (this.errTips = errTips)
        callback(new Error(errTips))
      } else {
        callback()
      }
    },

    async handleFileChange (file, fileList) {
      // 新增或替换
      try {
        this.uploading = true
        const { key } = await PUT_IMAGE_UPLOAD(file)
        this.form.packageUrl = key
        this.fileList = [file]
      } catch (e) {
        this.fileList = []
      } finally {
        this.uploading = false
      }
    },

    handleRemoveFile (file, fileList) {
      this.form.packageUrl = ''
      this.fileList = []
    }
  }
}
</script>

<style lang="scss" scoped>
.err-tips {
  color: #F26552;

  /deep/ .el-form-item__content {
    text-align: center;
    font-size: 16px;
    background: rgba(255,242,244,1);
    border: 1px solid rgba(242,161,150,1);
  }

  .el-icon {
    margin-right: .8rem;
  }
}

.el-dialog__wrapper {
  /deep/ .el-dialog__footer {
    text-align: center;
  }
}
</style>
